import { useMemo } from 'react';

import { useCardOfferDataContext } from '../../../context/selectors';

export const usePromotionTitle = (): string => {
  const {
    extendedProperties: { auction, offerServices },
  } = useCardOfferDataContext();

  return useMemo(() => {
    switch (true) {
      case offerServices?.isPremium:
        return 'Премиум';

      case offerServices?.isStandard:
        return 'Стандарт';

      case offerServices?.isTop3: {
        const bet = auction?.cpcBet;

        return `Топ ${bet ? `+ ${bet} ₽` : ''}`.trimEnd();
      }

      default:
        return '';
    }
  }, [auction, offerServices]);
};
